import * as React from "react";
import {cx} from "emotion";

import "./sc-template-card.scss";

import {to_imgToSmall}     from "@Common/logic/template-options/template-options-image-to-small";
import {to_imgToUltra}     from "@Common/logic/template-options/template-options-image-to-ultra";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {Load2}             from "@Common/react/load2";
import {UseState}          from "@Common/react/use-state";
import {ImageGalleryModal} from "@Common/ui-components/image-gallery-modal/image-gallery-modal";
import {chain}             from "@Common/utils/fs";
import {values}            from "@Common/utils/objects";

import {CommentEditModal} from "./comment-edit-modal/comment-edit-modal";

export const ScTemplateCard = ({next}) => cs(
    consumeContext("proofImgsCache"),
    ["commentEditModal", (_, next) => CommentEditModal({next})],
    ["imageGalleryModal", (_, next) => ImageGalleryModal({next})],

    ({commentEditModal, imageGalleryModal, proofImgsCache}) => next({
        renderCard: ({label, description, commentChanging=undefined, template, comment, defaultComment, maxCommentLength=100}) => cs(
            ["imgs", (_, next) => next(values(template?.images ??{}).map(({url}) => ({
                thumbnail: to_imgToSmall(url),
                enlarged: to_imgToUltra(url),
            })))],
            ({imgs}) => (
                <div {...{
                    className: "sc-template-card-235",

                    "xd-qa-type": "card",
                    "xd-qa-name": "Edition " + label,
                }}>
                    <div className="header">
                        <div className="left">
                            <div {...{
                                className: "label",
                                "xd-qa-type": "label",
                                "xd-qa-name": label,
                            }}>
                                {label}
                            </div>
                        </div>

                        <div className="thumbnail">
                            {cs(
                                ["proofImgsCache1", (_, next) => next(proofImgsCache(template.id))],
                                ({proofImgsCache1}) => (
                                    <img {...{
                                        src: proofImgsCache1.getLoaded()?.jpg[0] ?? chain(
                                            imgs?.[0],
                                            (_) => _?.thumbnail ?? _?.enlarged,
                                        ),
                                        onClick: () => imgs?.length && imageGalleryModal.show({
                                            renderImgs: (next) => cs(
                                                ["data", ({}, next) => Load2({
                                                    fetch: () => proofImgsCache1.load(),
                                                    next,
                                                })],
                                                ({data}) => next({
                                                    loading: data.loading,
                                                    value: imgs,
                                                    ...!data.loading && {
                                                        value: data.value.jpg.map((url) => ({enlarged: url})),
                                                    },
                                                }),
                                            ),
                                        }),
                                        "xd-qa-type": "image",
                                        "xd-qa-name": "Edition Image",
                                    }}/>
                                )
                            )}

                            <div className="preview">
                                <div className="icon">
                                    <i className="fa fa-search"/>
                                </div>

                                <div className="text">
                                    Proof Preview
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="comment">
                        <div className="label">
                            <div {...{
                                className: "text",
                                "xd-qa-type": "label",
                                "xd-qa-name": "Comment",
                            }}>
                                Comment
                            </div>

                            {commentChanging && (
                                <i {...{
                                    className: "fa fa-pencil",
                                    onClick: () => commentEditModal.show({
                                        title: label + " Comment",
                                        value: comment,
                                        defaultValue: defaultComment,
                                        description,
                                        onChange: commentChanging.onChange,
                                        onReset : commentChanging.onReset,
                                    }),
                                    "xd-qa-type": "link",
                                    "xd-qa-name": "Edit Comment",
                                }}/>
                            )}
                        </div>
                        {cs(
                            ["text", (_, next) => next(comment || defaultComment)],
                            ["needCollapsing", ({text}, next) => next(text?.length > maxCommentLength)],
                            ["collapsed", (_, next) => UseState({initValue: true, next})],
                            ({collapsed, needCollapsing, text}) => (
                                <div className={cx("content", {collapsed: needCollapsing && collapsed.value})}>
                                    <div {...{
                                        className: "text",
                                        "xd-qa-type": "text",
                                        "xd-qa-name": "Comment",
                                    }}>
                                        {!needCollapsing || !collapsed.value ? (
                                            text
                                        ) : (
                                            text.substring(0, maxCommentLength - 3) + "…"
                                        )}
                                    </div>

                                    {needCollapsing && (
                                        <a {...{
                                            className: "expansion-control",
                                            onClick: () => collapsed.change(v=>!v),
                                            "xd-qa-type": "link",
                                            "xd-qa-name": "Expand Comment",
                                        }}>
                                            {collapsed.value ? (
                                                "+ More"
                                            ) : (
                                                "- Less"
                                            )}
                                        </a>
                                    )}
                                </div>
                            )
                        )}
                    </div>
                </div>
            ),
        ),
    })
);

